import { Collection } from 'modules/core/lib/mobx-rest'

import TerminationType from 'modules/payroll_bundle/store/models/TerminationType'

class TerminationTypes extends Collection<TerminationType> {
  get cacheKey(): string {
    return 'terminationTypes'
  }

  model() {
    return TerminationType
  }
}

const singleton: TerminationTypes = new TerminationTypes()

export default singleton
